<b3-modal [open]="true" overlay size="md" (b3-close)="close()">
  <b3-modal-header
    *ngIf="title"
    [heading]="title"
    aria-level="2"
    [icon]="headerIcon"
    [attr.icon-tone]="headerIconTone"
    [attr.close-aria-label]="closeButton ? 'Fechar' : null"
    (b3-close)="close()">
  </b3-modal-header>

  <b3-modal-body>
    <div class="box">
      <div id="modal-body-content">
        <div class="ml-4 mr-4 mb-2">
          <p>{{ content }}</p>
        </div>
      </div>
    </div>
  </b3-modal-body>

  <b3-modal-footer>
    <div *ngIf="modalType !== 'confirmation'" class="app-modal-confirmation__footer app-modal-confirmation__footer--end">
      <b3-button type="button" variant="outlined" tone="default" (b3-click)="openLinkSuporte()">
        Suporte B3
      </b3-button>
      <b3-button type="button" variant="filled" tone="default" (b3-click)="close()">
        Tentar novamente
      </b3-button>
    </div>

    <div *ngIf="modalType === 'confirmation'" class="app-modal-confirmation__footer">
      <b3-button type="button" variant="outlined" tone="default" id="modal_cancel" (b3-click)="close()">
        Não
      </b3-button>
      <b3-button type="button" variant="filled" tone="default" id="btn_confirm_modal" (b3-click)="confirm()">
        Sim
      </b3-button>
    </div>
  </b3-modal-footer>
</b3-modal>
